/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'
import { JBP_CONTRACT_FRAGMENT } from './JBPContractFragment'

export const WHOLE_JBP_AUDIT_FRAGMENT = gql`
  fragment WholeJBPAudit on JBPAudit {
    id
    startTime
    endTime
    employee {
      id
      email
      firstName
      lastName
    }
    coldVaultStatus
    questionStatus
    auditAnswers {
      id
      answeredYes
      questionId
      question
      images {
        id
        url
      }
    }
    displayAudits {
      id
      images {
        id
        url
      }
    }
    actualCategoryShelfShares {
      id
      owner
      shelfShare
      shelfNumber
      displayAudit {
        id
      }
      categoryRequirement {
        id
        name
      }
    }
    contract {
      ...JBPContract
    }
  }
  ${JBP_CONTRACT_FRAGMENT}
`
